import React from 'react';
import s from './DownloadStatement.module.css'
import {Api} from "../../../../../api/Api";
import {useAppSelector} from "../../../../../hooks/redux";

const DownloadStatement = (props: any) => {

    const token = useAppSelector(state => state.userReducer.user.userToken)

    const accountInfo = {
        accountNumber:  props?.dataForStatement?.accountNumber,
        dateFrom: props?.dataForStatement?.from,
        dateTo: props?.dataForStatement?.to,
        transferType: "all"
    }

    const getStatement = () => {
        Api.getStatement(token, accountInfo)
            .then((res: any) => {
                const url = process.env.REACT_APP_API_URL + res.data
                window.open(url, '_blank');
            }
        )
    }

    return (

        <div className={s.statementWrapper} >
            <div className={s.buttonsWrapper}>
                <p className={s.downloadTitle}>Download as</p>
                <p className={s.buttonTitle} onClick={() => getStatement()}>PDF</p>
                {/* <div className={s.separator}/> */}
                {/*<p className={s.buttonTitle}>XLSX</p>*/}
                {/*<div className={s.separator}/>*/}
                {/* <p className={s.buttonTitle}>CSV</p> */}
                {/*<div className={s.separator}/>*/}
                {/*<p className={s.buttonTitle}>LITAS-ESIS</p>*/}
                {/*<div className={s.separator}/>*/}
                {/*<p className={s.buttonTitle}>FIDAVISTA</p>*/}
            </div>

            {/*<div className={s.printWrapper}>*/}
            {/*    <img src={print} alt="print_icon"/>*/}
            {/*    <p className={s.print}>Print</p>*/}
            {/*</div>*/}
        </div>
    )
}


export default DownloadStatement
